<footer class="main-footer" id="footer">
  <div class="container">
    <div class="row">



      <div class="col-md-12">
        <div class="powered-by-eni">
          {{'Common.PoweredBy'|translate}}  
          <img src="assets/images/logo-eni.png">
        </div>
      </div>
    </div>
  </div>


</footer>